<mat-checkbox [checked]="tree.selectAll" (click)="tree.toggleSelectAll()" color="primary">Select All</mat-checkbox>

<mat-form-field class="filter-input">
  <mat-label>Filter by Name</mat-label>
  <input [formControl]="filterControl" matInput data-testid="filter" />
</mat-form-field>

<div *ngIf="tree.viewableDataSource.data.length > 0; else emptyMessage" id="provider-list-container">
  <cdk-virtual-scroll-viewport id="provider-viewport" itemSize="40" maxBufferPx="800" minBufferPx="400">
    <ng-container *cdkVirtualFor="let node of tree.viewableDataSource; trackBy: tree.trackById; templateCacheSize: 0">
      <div class="tree-node" [ngStyle]="{ 'paddingLeft.rem': node.level * 1.5 }">
        <ng-container
          *ngIf="node.expandable"
          [ngTemplateOutlet]="parentNode"
          [ngTemplateOutletContext]="{ $implicit: node }"
        ></ng-container>
        <ng-container
          *ngIf="!node.expandable"
          [ngTemplateOutlet]="regularNode"
          [ngTemplateOutletContext]="{ $implicit: node }"
        ></ng-container>
      </div>
    </ng-container>
  </cdk-virtual-scroll-viewport>
</div>
<ng-template #parentNode let-node>
  <button disableRipple="true" mat-button (click)="tree.toggleExpansion(node)">
    <mat-icon>{{ tree.isExpanded(node) ? 'expand_more' : 'chevron_right' }}</mat-icon>
  </button>
  <mat-checkbox
    color="primary"
    [checked]="tree.isSelected(node)"
    [indeterminate]="tree.isIndeterminate(node)"
    (change)="tree.toggleSelection(node)"
    data-testid="provider-node"
  >
    {{ node.display }}
  </mat-checkbox>
</ng-template>

<ng-template #regularNode let-node>
  <mat-checkbox
    class="leaf-node"
    data-testid="provider-node"
    [checked]="tree.isSelected(node)"
    (change)="tree.toggleSelection(node)"
    color="primary"
  >
    {{ node.display }}
  </mat-checkbox>
</ng-template>

<ng-template #emptyMessage>
  <div class="empty-tree-message">No providers to display</div>
</ng-template>
